import React, { useCallback, useState } from 'react';
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { forgotPassword } from '../../slices/authSlice';
import { showPromiseNotification } from '../../common/notification';
import { encryption } from '../../common/enc_dec';
import { useNavigate, useParams } from 'react-router-dom';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { useTranslation } from 'react-i18next';
import '../../i18';

const ForgetPassword = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { type } = useParams();

    const dispatch = useDispatch();
    const [phone, setPhone] = useState('91');

    const forgetPasswordSchema = Yup.object().shape({
        phone_number: Yup.lazy((value) =>
            type === 'mobile'
                ? Yup.string()
                    .trim()
                    .matches(
                        /^(\+\d{1,3}[- ]?)?\d{10}$/,
                        t('valid', { field: t("phone_number") })
                    )
                    .required(t("required", { field: t("phone_number") }))
                : Yup.mixed().notRequired()
        ),
        email: Yup.lazy((value) =>
            type === 'email'
                ? Yup.string()
                    .trim()
                    .email(t('valid', { field: t("email") }))
                    .required(t("required", { field: t("email") }))
                : Yup.mixed().notRequired()
        )
    });

    const formOptions = { resolver: yupResolver(forgetPasswordSchema) }
    const { register, handleSubmit, formState, reset } = useForm(formOptions);
    const { errors } = formState;

    const onSubmit = useCallback(
        async (values) => {
            const submissionData = type === 'mobile'
                ? { country_code: phone, phone_number: values.phone_number }
                : { email: values.email };
            const myPromise = new Promise((resolve, reject) => {
                dispatch(
                    forgotPassword({
                        payload: {
                            ...submissionData,
                        },
                    })
                )
                    .then((response) => {
                        if (response?.payload?.code === 200) {
                            resolve(response.payload);
                            reset();
                            localStorage.setItem("otpTimer", btoa("60"));
                            localStorage.setItem("otpGenerateTime", btoa(response.payload.data.generate_time))
                            const params = {}
                            params.is_forget = true;
                            if (type === 'mobile') {
                                params.country_code = response.payload.data.country_code;
                                params.phone_number = response.payload.data.phone_number;
                            }
                            else {
                                params.email = response.payload.data.email;
                            }
                            params.session_id = response.payload.data.session_id;
                            const queryString = encryption(params, true);
                            navigate(`/otp-verification?data=${encodeURIComponent(queryString)}`);
                        }
                        else {
                            reject(response.payload)
                        }
                    })
            });
            showPromiseNotification(myPromise);
        },
        [dispatch, navigate, reset, phone]
    )
    return (
        <>
            <div className="signin-page-area">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-xl-6 col-lg-7">
                            <form className="signin-inner" onSubmit={handleSubmit(onSubmit)}>
                                <div className="row">
                                    <div className="col-12">
                                        <div className="single-input-inner style-bg-border">
                                            <h4 className="SignInUpHeading">{t('forgetPasswordHeading')}</h4>
                                            <p className="ForgotText">
                                                {type === 'mobile' ? t('verificationCodeMessage', { field: t("phone_number") }) : t('verificationCodeMessage', { field: t("email") })}
                                            </p>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        {type === 'mobile' ? (
                                            <>
                                                <div className="single-input-inner style-bg-border mb-2"
                                                    style={{ display: 'flex', gap: '5px' }}
                                                >
                                                    <PhoneInput
                                                        country={'in'}
                                                        value={phone}
                                                        onChange={(phone, data) => {
                                                            setPhone(data.dialCode)
                                                        }}
                                                        inputProps={{
                                                            name: 'phone',
                                                            required: true,
                                                            autoFocus: true,
                                                            disabled: true
                                                        }}
                                                        containerStyle={{ width: '125px', height: '50px' }}
                                                        inputStyle={{ width: '100%', height: '100%' }}
                                                    />
                                                    <input type="number" placeholder={t("enterFieldName", { field: t("Phone_Number") })} name='phone_number' {...register('phone_number')}
                                                        onChange={(e) => {
                                                            const inputValue = e.target.value;
                                                            if (inputValue.length > 10) {
                                                                e.target.value = inputValue.slice(0, 10);
                                                            }

                                                            if (inputValue.length <= 10) {
                                                                e.target.value = inputValue;
                                                            }
                                                        }}
                                                    />
                                                </div>
                                                <p className="text-danger">
                                                    {errors.phone_number?.message}
                                                </p>
                                            </>
                                        ) : (
                                            <div className="single-input-inner style-bg-border">
                                                <input type="email" placeholder={t("enterFieldName", { field: t("Email_Address") })} name='email' {...register('email')} />
                                                <p className="text-danger">
                                                    {errors.email?.message}
                                                </p>
                                            </div>
                                        )}
                                    </div>
                                    <div className="col-12 mb-4 mt-4">
                                        <button className="btn btn-base w-100">
                                            {t('submit')}
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ForgetPassword;